import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import styles from './FJPhotoRemoveBgThumbnail.module.less';
import PropTypes from 'prop-types';
import FJPhotoRemoveBgThumbnailItem from './FJPhotoRemoveBgThumbnailItem';
import FJHorizontalScroller from '../../../../common/components/FJScroller/FJHorizontalScroller';
import CatalogIcon from '../../../../assets/svg/catalog.svg?react';
import classNames from 'classnames';
import { useRef, useEffect, useState, useCallback } from 'react';

const FJPhotoRemoveBgThumbnail = ({
    autoBgImageDataList,
    curSelectAutoBgImageIndex,
    handleClickItem,
    isShow,
    handleAddThumbnail,
    handleUpdateThumbnail,
}) => {
    const scrollRef = useRef(null);

    const [isShowLeftCatalog, setIsShowLeftCatalog] = useState(false);
    const [isShowRightCatalog, setIsShowRightCatalog] = useState(false);

    const _updateCatalogUI = useCallback(() => {
        if (!scrollRef.current) return;
        const scrollDom = scrollRef.current?.getScroller();
        setIsShowLeftCatalog(scrollDom.scrollLeft !== 0);
        setIsShowRightCatalog(scrollDom.offsetWidth + scrollDom.scrollLeft !== scrollDom.scrollWidth);
    }, [scrollRef]);

    useEffect(() => {
        _updateCatalogUI();

        window.addEventListener('resize', _updateCatalogUI);
        return () => {
            window.removeEventListener('resize', _updateCatalogUI);
        };
    }, [autoBgImageDataList, _updateCatalogUI]);

    const _switchPreview = isNext => {
        if (!scrollRef.current) return;
        const scrollDom = scrollRef.current?.getScroller();
        if (isNext) {
            scrollRef.current.scrollToLeft(scrollDom?.offsetWidth, 'smooth');
        } else {
            scrollRef.current.scrollToLeft(0, 'smooth');
        }
        setTimeout(() => {
            _updateCatalogUI();
        }, 600);
    };

    const scrollToSelectItem = useCallback(() => {
        if (!scrollRef.current || !isShow) return;

        const targetScrollLeft = Math.max(0, curSelectAutoBgImageIndex * (80 + 12) - 80 - 12);

        scrollRef.current.scrollToLeft(targetScrollLeft, 'smooth');

        setTimeout(() => {
            _updateCatalogUI();
        }, 600);
    }, [curSelectAutoBgImageIndex, isShow, _updateCatalogUI]);

    useEffect(() => {
        scrollToSelectItem();
    }, [isShow, scrollToSelectItem]);

    return (
        <div
            className={classNames(styles.panel, !isShow && styles.hide)}
            style={{ padding: isShowLeftCatalog || isShowRightCatalog ? '16px 28px' : '16px' }}
        >
            <FJHorizontalScroller className={styles.scroller} ref={scrollRef} onMouseWheel={_updateCatalogUI}>
                {autoBgImageDataList.map((item, index) => (
                    <FJHoverBoardGradation
                        key={item.id}
                        className={styles.item}
                        borderRadius={6}
                        isShowInBorder={true}
                        active={index === curSelectAutoBgImageIndex}
                        onClick={() => handleClickItem(index)}
                    >
                        <FJPhotoRemoveBgThumbnailItem
                            autoBgImageData={item}
                            handleAddThumbnail={handleAddThumbnail}
                            handleUpdateThumbnail={handleUpdateThumbnail}
                        />
                    </FJHoverBoardGradation>
                ))}
            </FJHorizontalScroller>

            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_left,
                    !isShowLeftCatalog ? styles.hide : '',
                )}
                onClick={() => _switchPreview(false)}
            >
                <CatalogIcon />
            </div>
            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_right,
                    !isShowRightCatalog ? styles.hide : '',
                )}
                onClick={() => _switchPreview(true)}
            >
                <CatalogIcon />
            </div>
        </div>
    );
};

FJPhotoRemoveBgThumbnail.propTypes = {
    autoBgImageDataList: PropTypes.array.isRequired,
    curSelectAutoBgImageIndex: PropTypes.number.isRequired,
    handleClickItem: PropTypes.func.isRequired,
    isShow: PropTypes.bool.isRequired,
    handleAddThumbnail: PropTypes.func.isRequired,
    handleUpdateThumbnail: PropTypes.func.isRequired,
};

export default FJPhotoRemoveBgThumbnail;
